import { get } from 'lodash';

import { FIELD_PATHS, FIELD_VALUES } from '@funnels/constants';
import { StoreApplicant } from '@funnels/types';

export default function getApplicantName(
  applicants: StoreApplicant[],
  applicantId: string | undefined,
  defaultName = ''
): string {
  const applicantIndex: number = applicants.findIndex((a: StoreApplicant) => a.id === applicantId);

  if (applicantIndex === -1) {
    return defaultName;
  }

  const entity = get({ applicants }, FIELD_PATHS.APPLICANT_ENTITY(applicantIndex));

  if (entity === FIELD_VALUES.COMPANY) {
    return get({ applicants }, FIELD_PATHS.APPLICANT_COMPANY_NAME(applicantIndex), '');
  } else if (entity === FIELD_VALUES.TRUST) {
    return get({ applicants }, FIELD_PATHS.APPLICANT_TRUST_NAME(applicantIndex), '');
  }

  const firstName = get({ applicants }, FIELD_PATHS.APPLICANT_FIRST_NAME(applicantIndex), '');
  const lastName = get({ applicants }, FIELD_PATHS.APPLICANT_LAST_NAME(applicantIndex), '');

  if (!firstName && !lastName) {
    return defaultName;
  }

  if (!firstName || !lastName) {
    return `${firstName}${lastName}`;
  }

  return `${firstName} ${lastName}`;
}
